import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';

import { type Event } from 'hb-react/shared/apps/Events';

interface PayButtonsProps {
  breakpoint: string;
  event: Pick<Event, 'can_pay_later' | 'can_pay_now'>;
  isFixed?: boolean;
  isSubmitting?: boolean;
  isValid?: boolean;
  onPayLater?: () => void;
  submitForm?: () => void;
}

const PayButtons = ({
  breakpoint,
  event,
  isValid = false,
  isFixed = false,
  isSubmitting = false,
  onPayLater,
  submitForm,
}: PayButtonsProps) => (
  <WrapperButtonPay $isFixed={isFixed} $breakpoint={breakpoint}>
    {event.can_pay_later && (
      <Button
        variant="secondary"
        mr={{ _: 0, m: 2 }}
        pl={0}
        isDisabled={!isValid}
        onClick={onPayLater}
        isLoading={isSubmitting}
        type="button"
      >
        {s__(`NetworkEvents|Pay later`)}
      </Button>
    )}

    {event.can_pay_now && (
      <CustomNextButton
        dataTestId={`billing-information-step-${isFixed ? 'next' : 'pay-now'}`}
        onClick={() => {
          submitForm?.();
        }}
        isDisabled={!isValid}
        isLoading={isSubmitting}
        $isFixed={isFixed}
        $breakpoint={breakpoint}
      >
        {isFixed ? s__(`NetworkEvents|Next`) : s__(`NetworkEvents|Pay now`)}
      </CustomNextButton>
    )}
  </WrapperButtonPay>
);

export default PayButtons;

const WrapperButtonPay = styled(Box)<{
  $breakpoint: string;
  $isFixed: boolean;
}>`
  flex-direction: ${({ $isFixed, $breakpoint }) =>
    $isFixed && $breakpoint === 's' && 'column-reverse'};
`;

const CustomNextButton = styled(Button)<{
  $breakpoint: string;
  $isFixed: boolean;
}>`
  margin-bottom: ${({ $isFixed, $breakpoint }) =>
    $isFixed && $breakpoint === 's' && '12px'};
  max-width: ${({ $isFixed }) => $isFixed && '133px'};
`;
